import { ContactUs, FadeIn, Footer, GradientBg, Header } from "../components"
import type { NextPage } from "next"
import { NextSeo } from "next-seo"
import Link from "next/link"
import { useRouter } from "next/router"

const people = [
  {
    name: "Ralph Betesh",
    role: "Co-Founder & CEO",
    imageUrl:
      "https://coverdash.s3.amazonaws.com/images/coverdash.com/ralph_betesh_headshot.jpg",
    linkedinUrl: "https://www.linkedin.com/in/ralphbetesh/",
  },
  {
    name: "Avery Rubin",
    role: "Co-Founder & CTO",
    imageUrl:
      "https://coverdash.s3.amazonaws.com/images/coverdash.com/avery_rubin_headshot.jpg",
    linkedinUrl: "https://www.linkedin.com/in/avery-rubin/",
  },
  {
    name: "Perry Raskin",
    role: "Head of Web & Integrations",
    imageUrl: "https://coverdash.s3.amazonaws.com/images/perry_headshot.jpg",
    linkedinUrl: "https://www.linkedin.com/in/perryraskin/",
  },
  {
    name: "Max Kufel",
    role: "Chief of Staff",
    imageUrl:
      "https://coverdash.s3.amazonaws.com/images/coverdash.com/max_kufel_headshot.jpeg",
    linkedinUrl: "https://www.linkedin.com/in/maxjosephkufel/",
  },
  {
    name: "Bobby Jones",
    role: "Head of Partnerships",
    imageUrl:
      "https://coverdash.s3.amazonaws.com/images/coverdash.com/bobby_jones_headshot.jpeg",
    linkedinUrl: "https://www.linkedin.com/in/robert-jones-03a7bb86/",
  },
  {
    name: "Matthew Brunwasser",
    role: "Head of People Operations",
    imageUrl:
      "https://coverdash.s3.amazonaws.com/images/coverdash.com/matthew_brunwasser_headshot.jpg",
    linkedinUrl: "https://www.linkedin.com/in/matthew-brunwasser/",
  },
]

const investors = [
  {
    name: "NYCA Partners",
    imageName: "nyca",
  },
  {
    name: "Axis Capital",
    imageName: "axis",
  },
  {
    name: "Tokio Marine",
    imageName: "tokio-marine",
  },
  {
    name: "Bling Capital",
    imageName: "bling",
  },
  {
    name: "Cameron Ventures",
    imageName: "cameron-ventures",
  },
  {
    name: "Expansion VC",
    imageName: "expansion-ventures",
  },
  // {
  //   name: 'MidOcean Partners',
  //   imageName: 'midocean-partners'
  // },
  // {
  //   name: 'Vantage Insurance',
  //   imageName: 'vantage'
  // }
]

// const newsOutlets = [
//   {
//     name: "TechCrunch",
//     imageName: "techcrunch",
//     url: "https://techcrunch.com/2023/01/23/bling-capital-coverdash-insurtech/",
//   },
//   {
//     name: "Yahoo Finance",
//     imageName: "yahoo-finance",
//     url: "https://www.yahoo.com/entertainment/bling-capital-backed-coverdash-unveils-161540538.html",
//   },
//   {
//     name: "PYMNTS",
//     imageName: "pymnts",
//     url: "https://www.pymnts.com/insurance/2023/coverdash-launches-embedded-business-insurance-solutions/",
//   },
//   {
//     name: "Fintech Finance",
//     imageName: "fintech-finance",
//     url: "https://ffnews.com/newsarticle/business-focused-insurtech-coverdash-announces-launch-after-oversubscribed-seed-round/",
//   },
// ]

const Team: NextPage = () => {
  const router = useRouter()
  const canonicalUrl = (
    `https://www.coverdash.com` + (router.asPath === "/" ? "" : router.asPath)
  ).split("?")[0]
  return (
    <>
      <NextSeo
        title="About Us"
        description="Learn about Coverdash: mission, leadership, and investors. We make business insurance accessible through embedded technology for every business. — Coverdash"
        canonical={canonicalUrl}
        openGraph={{
          url: canonicalUrl,
          title: "About Us",
          description:
            "Learn about Coverdash: mission, leadership, and investors. We make business insurance accessible through embedded technology for every business. — Coverdash",
        }}
      />
      <div className="overflow-hidden">
        <GradientBg />
        <Header />

        <div className="h-screen flex flex-col justify-center bg-gradient-to-br e from-green-100  to-white">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <FadeIn>
                <h1 className="text-4xl tracking-tight font-extrabold sm:text-5xl md:text-6xl">
                  <span className="block text-primary">About Us</span>
                  <span className="block text-alt mt-2 sm:mt-3">
                    Business insurance in a{" "}
                    <span className="text-primary">dash.</span>
                  </span>
                </h1>
              </FadeIn>

              <p className="mt-4 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-8 md:text-xl md:max-w-3xl">
                Focused on making insurance accessible to businesses of all
                shapes and sizes. Through our cutting-edge embedded technology,
                businesses can source their appropriate insurance coverage at
                the places they transact most.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="mx-auto py-16 px-4 max-w-7xl sm:px-6 lg:px-8 ">
            <div className="space-y-12">
              <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl mx-auto text-center">
                <FadeIn>
                  <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl text-alt">
                    Our leadership
                  </h2>
                  <p className="mt-5 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-8 md:text-xl md:max-w-3xl">
                    Leadership of insurtech, technology, financial services, and
                    operations experts who share the common goal of making
                    insurance accessible to businesses of all shapes and sizes
                  </p>
                </FadeIn>
              </div>
              <ul
                role="list"
                className="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 md:grid-cols-3 lg:grid-cols-3 lg:gap-x-10"
              >
                {people.map((person, index) => (
                  <FadeIn delay={index / 10} key={index}>
                    <li>
                      <div className="space-y-4">
                        <a href={person.linkedinUrl}>
                          <div className="aspect-w-4 aspect-h-3">
                            <img
                              className="object-cover shadow-lg rounded-lg max-w-xs"
                              src={`${person.imageUrl}?sig={${index}}`}
                              alt={`Profile picture of ${person.name} - ${person.role}`}
                            />
                          </div>
                        </a>

                        <div className="space-y-2">
                          <div className="md:text-lg lg:text-base leading-6 font-medium space-y-1">
                            <h3>{person.name}</h3>
                            <p className="text-primary">{person.role}</p>
                          </div>
                          <ul role="list" className="flex space-x-5">
                            <li>
                              <a
                                href={person.linkedinUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-400 hover:text-blue-800 transition-all"
                              >
                                <span className="sr-only">LinkedIn</span>
                                <svg
                                  className="w-5 h-5"
                                  aria-hidden="true"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </FadeIn>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* JOIN US - CAREERS */}
        <div className="py-16 max-w-5xl mx-auto px-2 sm:px-0">
          <FadeIn>
            <div className="bg-gray-100 rounded-xl">
              <div className="max-w-2xl mx-auto text-center py-8 px-4 sm:px-6 md:py-12 lg:px-8">
                <h2 className="text-4xl font-extrabold font-brand text-alt sm:text-4xl">
                  Join us
                </h2>
                <p className="mt-4 text-lg leading-6 text-gray-600">
                  Interested in a career with us? Check out our open job
                  opportunities.
                </p>
                <Link
                  href="/careers"
                  className="mt-8 btn-primary font-semibold"
                >
                  See openings
                </Link>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* INVESTORS */}

        <div className="hidden py-16 max-w-5xl mx-auto">
          <p className="uppercase tracking-wider text-gray-400 font-semibold text-sm text-center">
            Investors
          </p>
          <div className="pt-8 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-3">
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="/img/logos/bling.png"
                alt="Bling Capital"
              />
            </div>

            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-8"
                src="/img/logos/AXIS_Capital_Updated_Logo.jpg"
                alt="AXIS Capital"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-10"
                src="/img/logos/cameron_ventures.png"
                alt="Cameron Ventures"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-8"
                src="/img/logos/expvc-logo-big.png"
                alt="Expansion VC"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-8"
                src="/img/logos/MidOcean.jpg"
                alt="MidOcean Partners"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-10"
                src="/img/logos/og-crc.png"
                alt="CRC Insurance"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-10"
                src="/img/logos/vantage.png"
                alt="Vantage Insurance"
              />
            </div>
          </div>
        </div>

        <div className="bg-alt">
          <div className="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8">
            <FadeIn>
              <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl text-white text-center">
                Our investors
              </h2>
              <div className="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-12">
                {investors.map(({ name, imageName }) => (
                  <div
                    key={name}
                    className="col-span-1 flex justify-center py-8 px-8 bg-gray-900/20"
                  >
                    <img
                      className="max-h-12"
                      src={`/img/investors/${imageName}.svg`}
                      alt={`${name} Logo`}
                      aria-hidden="true"
                    />
                  </div>
                ))}
              </div>
            </FadeIn>
          </div>
        </div>

        {/* <div id="press" className="max-w-7xl mx-auto py-16 px-4 sm:px-6">
          <FadeIn>
            <h2 className="text-4xl text-alt font-extrabold mb-8 text-center tracking-tight">
              Coverdash in the <span className="text-primary">press</span>
            </h2>
            <div className="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-4 lg:mt-12">
              {newsOutlets.map(({ name, imageName, url }) => (
                <div
                  key={name}
                  className="col-span-1 flex justify-center py-8 px-8"
                >
                  <a href={url} target="_blank" rel="noreferrer">
                    <img
                      className="max-h-12"
                      src={`/img/newsOutlets/${imageName}.png`}
                      alt={`${name} Logo`}
                      aria-hidden="true"
                    />
                  </a>
                </div>
              ))}
            </div>
          </FadeIn>
        </div> */}

        <div id="contact-us" className="max-w-7xl mx-auto py-16 px-4 sm:px-6">
          <FadeIn>
            <h2 className="text-5xl text-alt font-bold mb-8 text-center tracking-tight">
              Send us a <span className="text-primary">message</span>
            </h2>
          </FadeIn>
          <div className="max-w-xl mx-auto mt-12">
            <ContactUs page="team" />
          </div>
        </div>

        <Footer />
      </div>
    </>
  )
}

export default Team
